import { z } from 'zod';
/**
 * Query parameters `GET /admin/worker-activity/summary` accepts, which counts the blocks workers
 * are running or waiting on right now.
 */
export const FlowWorkerActivitySummaryQuerySchema = z.object({
    organizationId: z
        .uuid()
        .describe('Count only this organization, within whatever the caller may see.')
        .optional(),
});
//# sourceMappingURL=workerActivity.js.map